import React from "react";
import { observer } from "mobx-react";
import { AiSearchHero } from "../AiSearchBox";
import { dataSearchState } from "../state";
import PendingTableOutline from "./PendingTableOutline";

const STEPS = [
  {
    num: "1",
    icon: "tune",
    title: "Describe or filter",
    desc: "Describe who you want above, or filter by title, company size, location, industry, and more on the left."
  },
  {
    num: "2",
    icon: "search",
    title: "Browse results",
    desc: "Matching contacts and companies appear instantly. Refine filters to zero in on your ICP."
  },
  {
    num: "3",
    icon: "send",
    title: "Add or export",
    desc: "Save to a list, export as CSV, or launch a Salesgear campaign directly from the results."
  }
];

const NoFilterApplied = () => {
  const companies = dataSearchState.activeSearchTab === "companies";
  // Filters picked, not searched: the banner above holds the one action (Search). Show where results will land
  // rather than the AI console, which would replace those filters.
  if (dataSearchState.isStartPagePending(companies)) return <PendingTableOutline companies={companies} />;
  return (
    <div className="noFilters listBuilderInitial">
      <div className="lbEmpty">
        <AiSearchHero />
        <div className="lbEmptySteps">
          <p className="lbEmptyStepsHeading">How it works</p>
          <div className="lbEmptyStepsList">
            {STEPS.map((step, i) => (
              <React.Fragment key={i}>
                <div className="lbEmptyStep">
                  <div className="lbEmptyStepHeader">
                    <span className="lbEmptyStepNum">{step.num}</span>
                    <span className="material-symbols-outlined lbEmptyStepIcon" aria-hidden="true">{step.icon}</span>
                  </div>
                  <h3 className="lbEmptyStepTitle">{step.title}</h3>
                  <p className="lbEmptyStepDesc">{step.desc}</p>
                </div>
                {i < STEPS.length - 1 && (
                  <div className="lbEmptyStepArrow" aria-hidden="true">
                    <span className="material-symbols-outlined">chevron_right</span>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export { NoFilterApplied };
export default observer(NoFilterApplied);
